import { render, staticRenderFns } from "./MaterialStandardMappingList.vue?vue&type=template&id=1da27246&scoped=true&"
import script from "./MaterialStandardMappingList.vue?vue&type=script&lang=js&"
export * from "./MaterialStandardMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da27246",
  null
  
)

export default component.exports